import React from 'react';
export default function Indentation(props) {
    return (React.createElement("div", { className: "fabric-editor-block-mark fabric-editor-indentation-mark", "data-level": props.level }, props.children));
}
//# sourceMappingURL=indentation.js.map